<template>
  <div>
    <div class="top-bar">
      <span @click="goBackToBandPage">
        <i class="left"></i>
      </span>
      <span class="heading_new">History</span>
      <span class="spacer" />
    </div>
    <pop-up-message
            v-if="showSuccessMsg"
            :message="`Salary Revision has  been successfully Deleted`"
            btnText="Back"
            @back="()=>showSuccessMsg =!showSuccessMsg"
          />
          <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
    <div class="main-container">
      <ctc-details-card
        class="cardClass"
        :photo_url="employeeDetails.photo_url"
        :empName="employeeDetails.name"
        :empId="employeeDetails.code"
        :empMail="employeeDetails.email"
        :ctcDetails="true"
        :currCTC="employeeDetails.reviseSalary[0]"
        @click="closeCard"
      >
      </ctc-details-card>
      <div class="revMessage" v-show="historyData.length == 0">
        <p>There is no Salary Revision for this Employee</p>
      </div>
      <div
        class="margin-t-25px"
        v-for="(revSalaryObj, index) of historyData"
        :key="index"
      >
        <tl-accordion :headerName="revSalaryObj.revision">
          <div slot="accordionBody">
            <div class="revisedSalaryHistory">
              <div>
                <p>
                  CTC : <b>{{ revSalaryObj.ctc }}/-Per Annum</b>
                </p>
                <p>
                  Effective Date : <b>{{ revSalaryObj.from }}</b>
                </p>
              </div>
              <div v-if="index == historyData.length - 1">
                <p>
                  Delete
                  <img
                    src="@/assets/delete.svg"
                    @click="() => (showConfirmDelete = true)"
                  />
                </p>
                <pop-up-message
                  v-if="showConfirmDelete"
                  :message="`Are you sure want to delete ${revSalaryObj.revision} ?`"
                  :popupType="popupType"
                  :popupHeaderMessage="'Confirm Delete'"
                >
                  <template v-slot:bottomContent>
                    <div class="popup-btn-group">
                      <button
                        class="btn-popup-secondary"
                        type="button"
                        @click="()=>showConfirmDelete = !showConfirmDelete"
                      >
                        Cancel
                      </button>
                      <button
                        class="btn-popup"
                        type="button"
                        @click="()=> deleteLastRevisedSalary()"
                      >
                        Delete
                      </button>
                    </div>
                  </template>
                </pop-up-message>
              </div>
            </div>

            <div class="datatableClass">
              <data-table
                :columns="historyDataCols"
                :tableData="revSalaryObj.details"
                :checkbox="false"
                :showedit="false"
                :showdelete="false"
                :showhistory="false"
              >
                <template v-slot:rowcontent="slotprops">
                  <p>
                    {{ slotprops.value.record[slotprops.value.column.key] }}
                  </p>
                </template>
              </data-table>
            </div>
          </div>
        </tl-accordion>
      </div>
    </div>
    <bottom-action-container>
      <btn-grp slot="end">
        <!-- <img src="@/assets/download.svg" />
        <span class="downloadClass">Download Revision History</span> -->
        <btn text="Back" type="secondary" @click="goBackToBandPage" />
      </btn-grp>
    </bottom-action-container>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import CtcDetailsCard from "@/components/dashboard/ctcDetailsCard.vue";
export default {
  components: {
    SearchDropdown,
    CtcDetailsCard,
  },
  props: {
    employeeDetails: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      errmsg:"",
      toast:false,
      showSuccessMsg:false,
      showConfirmDelete: false,
      loginId:"",
      department: "",
      designation: "",
      costCentre: "",
      departmentOptions: [],
      designationOptions: [],
      costCentreOptions: [],
      showHistoryPopup: false,
      employeeData: [],
      historyDataCols: [
        {
          label: "Component Name",
          key: "name",
        },
        {
          label: "Monthly Salary ",
          key: "monthly",
        },
        {
          label: "Annual Salary ",
          key: "annual",
        },
      ],
      historyData: [],
      initialData: [],
    };
  },
  mounted() {
    this.getHistoryData();
    this.loginId = localStorage.getItem("loginId")
  },
  activated() {
    this.fetchAll();
    this.getHistoryData();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapState({
      reviseSalaryData: (state) => state.dashboard.revisesalary.revisesalary,
      employeesJoiningsData: (state) => state.dashboard.joinings.joinings, //fetch employees data
    }),
  },
  methods: {
    ...mapActions({
      act_fetchAll:
        "dashboard/payroll/utilities/revisesalary/fetchReviseSalary",
      act_delete_revised_salary:
        "dashboard/payroll/utilities/revisesalary/deleteReviseSalary",
    }),
    async deleteLastRevisedSalary(){
      try{
         let payload={
          employee_id:this.employeeDetails.id,
          ip_address:"ip not found",
          email:this.loginId
         }
         let res = await this.act_delete_revised_salary(payload)
         if(res.status){
          this.showConfirmDelete=false
          this.showSuccessMsg = true
          this.goBackToBandPage()

         }

      }catch(err){
        this.showConfirmDelete=false
        this.goBackToBandPage()
        this.toast = true;
        this.errmsg = err;
      }
    },
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.paygroupId);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    getHistoryData() {
      try {
        if (this.employeeDetails) {
          // let historyLength = this.employeeDetails.EmployeeSalarySetting[0].history_salary_structure ? this.employeeDetails.EmployeeSalarySetting[0].history_salary_structure.length : 0;
          this.historyData = this.employeeDetails.EmployeeSalarySetting[0]
            .history_salary_structure
            ? this.employeeDetails.EmployeeSalarySetting[0]
                .history_salary_structure
            : [];
          this.historyData.map((el, index) => {
            el.revision = `Revision ${index + 1}`;
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    showHistory(val) {
      this.showHistoryPopup = true;
      this.$emit("showHistoryPage", val);
    },
    goBackToBandPage() {
      this.$emit("hideHistoryPage");
    },
    closeCard() {},
  },
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  margin-left: 20px;
  background-color: #34c0be;
  display: flex;
}
.heading_new {
  width: 270px;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.revMessage {
  margin: 80px 0 0 35%;
  font-size: large;
  font-weight: bold;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}
.downloadClass {
  font-family: Montserrat;
  font-size: 12px;
  color: #37c6c0;
  margin-right: 10px;
  margin-top: 15px;
}
img {
  margin-right: 10px;
}
.revisedSalaryHistory {
  display: flex;
  justify-content: space-between;
}
</style>
